<template>
  <header class="brand-nav">
    <div class="brand-nav__bar">
      <nav class="brand-nav__links" aria-label="Primary">
        <router-link class="brand-nav__link" to="/products">THE DRINK</router-link>
        <button class="brand-nav__link brand-nav__story" type="button" aria-haspopup="dialog" @click="playFamilyStory">MEET BANJINO</button>
      </nav>

      <div class="brand-nav__mark">
        <router-link to="/" aria-label="Banjino's home">
          <img src="/assets/brand/wordmark.svg" alt="Banjino's" />
        </router-link>
      </div>

      <div class="brand-nav__action">
        <BrandButton variant="green" small :to="cartCount > 0 ? '/cart' : '/products'" :aria-label="cartCount > 0 ? `Cart, ${cartCount} bottles` : 'Shop'">
          {{ cartCount > 0 ? `CART · ${cartCount}` : 'SHOP' }}
        </BrandButton>
      </div>

      <button
        ref="menuButton"
        class="brand-nav__burger"
        type="button"
        :aria-expanded="open ? 'true' : 'false'"
        aria-label="Menu"
        @click="open = !open"
      >
        <span></span><span></span><span></span>
      </button>
    </div>

    <div v-if="open" class="brand-nav__drawer">
      <router-link class="brand-nav__link" to="/products" @click="open = false">THE DRINK</router-link>
      <button class="brand-nav__link brand-nav__story" type="button" aria-haspopup="dialog" @click="playFamilyStory">MEET BANJINO</button>
      <router-link class="brand-nav__link" to="/products" @click="open = false">SHOP</router-link>
      <router-link class="brand-nav__link" to="/cart" @click="open = false">
        {{ cartCount > 0 ? `CART · ${cartCount}` : 'CART' }}
      </router-link>
    </div>

    <VideoStoriesDialog ref="stories" @restore-focus="restoreStoryFocus" />
  </header>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useCartStore } from '@/stores/cart'
import BrandButton from './BrandButton.vue'
import VideoStoriesDialog from './VideoStoriesDialog.vue'

const cartStore = useCartStore()
const route = useRoute()
const open = ref(false)
const menuButton = ref(null)
const stories = ref(null)
let storyTrigger = null

const cartCount = computed(() => cartStore.itemCount)

function playFamilyStory (event) {
  storyTrigger = event.currentTarget
  open.value = false
  stories.value.show()
}

function restoreStoryFocus () {
  const focusTarget = storyTrigger?.isConnected ? storyTrigger : menuButton.value
  focusTarget?.focus()
}

watch(() => route.fullPath, () => { open.value = false })
</script>

<style scoped>
.brand-nav {
  position: sticky;
  top: 0;
  z-index: 100;
  background: var(--bj-bg);
  border-bottom: 1px solid var(--bj-hairline);
}

.brand-nav__bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 64px;
}

.brand-nav__links { display: flex; align-items: center; gap: 34px; width: 320px; }

.brand-nav .brand-nav__link {
  font-family: var(--bj-font-ui) !important;
  font-size: 12px !important;
  font-weight: 700;
  letter-spacing: 0.18em;
  color: var(--bj-green);
  text-decoration: none;
}
.brand-nav__link:hover { color: var(--bj-orange-dark); }
.brand-nav__link:focus-visible { outline: 2px solid var(--bj-orange); outline-offset: 3px; }

.brand-nav .brand-nav__story {
  background: transparent !important;
  border: 0;
  border-radius: 0;
  box-shadow: none !important;
  padding: 0;
  margin: 0;
  height: auto;
  min-width: 0;
  min-height: 0;
  justify-content: flex-start;
  line-height: inherit;
  text-align: left;
  cursor: pointer;
  transform: none !important;
}

.brand-nav__mark { flex-grow: 1; display: flex; justify-content: center; }
.brand-nav__mark img { height: 44px; display: block; }

.brand-nav__action { width: 320px; display: flex; justify-content: flex-end; }

.brand-nav .brand-nav__burger {
  display: none !important;
  background: transparent !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
}
.brand-nav__burger span {
  display: block;
  width: 22px;
  height: 2px;
  background: var(--bj-green);
}
.brand-nav__burger:focus-visible { outline: 2px solid var(--bj-orange); outline-offset: 2px; }

.brand-nav__drawer {
  display: none;
  flex-direction: column;
  gap: 20px;
  padding: 8px 24px 24px;
  border-top: 1px solid var(--bj-hairline);
}
.brand-nav__drawer .brand-nav__link { min-height: 44px; display: flex; align-items: center; }

@media (max-width: 960px) {
  .brand-nav__bar { padding: 16px; gap: 12px; }
  .brand-nav__links { display: none; }
  .brand-nav__action { width: auto; flex: none; }
  .brand-nav__action :deep(.bj-btn) { padding: 12px 16px; min-height: 44px; }
  .brand-nav__mark { justify-content: flex-start; }
  .brand-nav__mark img { height: 34px; }
  .brand-nav .brand-nav__burger { display: flex !important; }
  .brand-nav__drawer { display: flex; }
}
</style>
